export const MAX_UNDO_TIMELINE_LENGTH = 50;
